// extracted by mini-css-extract-plugin
export var settingsList = "_36-0";
export var settingsRow = "_36-1";
export var warningDot = "_36-2";